export default {"src":"/_next/static/media/Rupee.9c9139d3.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};